// Original file: target/protobuf_external_src/hopper/subscription/bff/proto/v1/bff.proto

export const SubscriptionStatus = {
  SUBSCRIPTION_STATUS_UNSPECIFIED: 'SUBSCRIPTION_STATUS_UNSPECIFIED',
  SUBSCRIPTION_STATUS_NON_SUBSCRIBED: 'SUBSCRIPTION_STATUS_NON_SUBSCRIBED',
  SUBSCRIPTION_STATUS_PAID: 'SUBSCRIPTION_STATUS_PAID',
  SUBSCRIPTION_STATUS_FREE_TRIAL: 'SUBSCRIPTION_STATUS_FREE_TRIAL',
  SUBSCRIPTION_STATUS_TRIAL_CANCELED_ACTIVE: 'SUBSCRIPTION_STATUS_TRIAL_CANCELED_ACTIVE',
  SUBSCRIPTION_STATUS_TRIAL_CANCELED_INACTIVE: 'SUBSCRIPTION_STATUS_TRIAL_CANCELED_INACTIVE',
  SUBSCRIPTION_STATUS_PAID_CHURNED_ACTIVE: 'SUBSCRIPTION_STATUS_PAID_CHURNED_ACTIVE',
  SUBSCRIPTION_STATUS_PAID_CHURNED_INACTIVE: 'SUBSCRIPTION_STATUS_PAID_CHURNED_INACTIVE',
  SUBSCRIPTION_STATUS_INELIGIBLE: 'SUBSCRIPTION_STATUS_INELIGIBLE',
  SUBSCRIPTION_STATUS_PAID_CHURNED_BILLING: 'SUBSCRIPTION_STATUS_PAID_CHURNED_BILLING',
} as const;

export type SubscriptionStatus =
  | 'SUBSCRIPTION_STATUS_UNSPECIFIED'
  | 0
  | 'SUBSCRIPTION_STATUS_NON_SUBSCRIBED'
  | 1
  | 'SUBSCRIPTION_STATUS_PAID'
  | 2
  | 'SUBSCRIPTION_STATUS_FREE_TRIAL'
  | 3
  | 'SUBSCRIPTION_STATUS_TRIAL_CANCELED_ACTIVE'
  | 4
  | 'SUBSCRIPTION_STATUS_TRIAL_CANCELED_INACTIVE'
  | 5
  | 'SUBSCRIPTION_STATUS_PAID_CHURNED_ACTIVE'
  | 6
  | 'SUBSCRIPTION_STATUS_PAID_CHURNED_INACTIVE'
  | 7
  | 'SUBSCRIPTION_STATUS_INELIGIBLE'
  | 8
  | 'SUBSCRIPTION_STATUS_PAID_CHURNED_BILLING'
  | 9

export type SubscriptionStatus__Output = typeof SubscriptionStatus[keyof typeof SubscriptionStatus]
